// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf5db351","239":"549d6f72","453":"022726c8","667":"67745911"}[chunkId] + ".chunk.js";
};